import React from "react";

function Card({ children, extra, noAnimate, ...props }) {
  return (
    <div
      className={`card ${noAnimate ? "" : "card-enter"} ${extra || ""}`}
      {...props}
    >
      {children}
    </div>
  );
}

export default Card;
